import { render, staticRenderFns } from "./aib.vue?vue&type=template&id=05eac8e4&scoped=true&"
import script from "./aib.vue?vue&type=script&lang=js&"
export * from "./aib.vue?vue&type=script&lang=js&"
import style0 from "./aib.vue?vue&type=style&index=0&id=05eac8e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05eac8e4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VContainer,VFlex,VLayout,VSimpleTable})
